import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QueryKeys } from '../keys';
import { request } from '../request';

export const useDeleteBrandLogo = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await request(`/brands/${id}/logo`, { method: 'DELETE' });
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QueryKeys.user }),
  });
};
